<template>
    <section class="app-main">

        <div class="title">
            <p @click="$router.go(-1)"><i class="el-icon-back"></i>返回商品列表</p>
            <p>{{titleShow ?'添加商品':'修改商品'}}</p>
        </div>
        <el-card class="m-bottom-4">
                <el-row class="m-bottom-4">
                    <el-col :span="2" class="input-left">
                        开始时间：
                    </el-col>
                    <el-col :span="22">
                        <el-date-picker v-model="start_time" value-format="timestamp"  type="datetime" placeholder="选择开始时间" style="width:400px;"></el-date-picker>
                    </el-col>
                </el-row>
                <el-row class="m-bottom-4">
                    <el-col :span="2" class="input-left">
                        结束时间：
                    </el-col>
                    <el-col :span="22">
                        <el-date-picker v-model="end_time" value-format="timestamp"  type="datetime" placeholder="选择开始时间" style="width:400px;"></el-date-picker>
                    </el-col>
                </el-row> 
            </el-card>
            <el-card class="m-bottom-4">
                <el-row class="m-bottom-4">
                    <el-col :span="2" class="input-left">
                        商品名称：
                    </el-col>
                    <el-col :span="22">
                        <el-input v-model="$route.query.name" placeholder="" style="width:400px" readonly class="readonly"></el-input>
                    </el-col>
                </el-row>
                <el-row class="m-bottom-4" v-show="skuItems.length != 0">
                    <el-col :span="2" class="input-left">商品SKU:</el-col>
                    <el-col :span="20" style="overflow-y:auto">
                        <div class="sku-items-head">
                            <div class="m-width-145"><span>规格</span></div>
                            <!-- <div class="m-width-145"><span>规格(英)</span></div> -->
                            <div class="m-width-125"><span>原价(C$)</span></div>
                            <div class="m-width-125"><span>现有库存</span></div>
                            <div class="m-width-125"><span>最低价格(C$)</span></div>
                            <div class="m-width-125"><span>砍价库存</span></div>
                            <div class="m-width-125"><span>可砍次数</span></div>
                            <div class="m-width-125"><span>可购买数量</span></div>
                            <div class="m-width-125"><span>砍价类型</span></div>
                            <div class="m-width-165"><span>条形码</span></div>
                        </div>
                        <div class="sku-items-body" v-for="(it,index) in skuItems" :key="index">
                            <div class="m-width-145">
                                <p><span>{{it.attr_symbol_string}}</span></p>
                                <!-- <el-input v-model="it.attr_symbol_string"  size="small" readonly class="readonly">
                                </el-input> -->
                            </div>
                            <!-- <div class="m-width-145"><el-input v-model="it.attr_symbol_string_en"  size="small" readonly></el-input></div> -->
                            <div class="m-width-125"><el-input v-model="it.price"  size="small" readonly class="readonly"></el-input></div>
                            <div class="m-width-125"><el-input v-model="it.stock"  size="small" readonly class="readonly"></el-input></div>
                            <div class="m-width-125"><el-input v-model="it.sales_price"  size="small"></el-input></div>
                            <div class="m-width-125"><el-input v-model="it.sales_stock"  size="small"></el-input></div>
                            <div class="m-width-125"><el-input v-model="it.count"  size="small"></el-input></div>
                            <div class="m-width-125"><el-input v-model="it.buy_limit"  size="small"></el-input></div>
                            <div class="m-width-125">
                                <el-select v-model="it.cut_type"  placeholder="请选择">
                                    <el-option label="随便砍" value="0"> </el-option>
                                    <el-option label="一砍到底" value="1"> </el-option>
                                </el-select>
                            </div>
                            <div class="m-width-165"><el-input v-model="it.barcode"  size="small" readonly class="readonly"></el-input></div>
                        </div>
                        <el-button  @click="handleSkuCopy()" type="success" plain style="width:120px;margin-top:15px">一键填充</el-button>
                        <div class="sku-tips">Tips：所有属性都要填写，否则会添加商品失败；一键填充将所有最低价格、砍价库存、可看次数、可购买数量、砍价类型的数据等同于第一行的数据</div>
                    </el-col>
                </el-row>  
            </el-card>
            <el-card>
                <el-row class="m-bottom-4">
                    <el-col :span="2" class="input-left">
                        提交商品：
                    </el-col>
                    <el-col :span="22">
                        <el-button  @click="handleSubmit()" type="success" plain style="width:150px">确认</el-button>
                    </el-col>
                </el-row>
            </el-card>
    </section>
</template>
<script>
import { parseTime } from "@/untils/index.js"

import { goods_sku } from "@/api/goods.js"
import { add_bargain_goods, put_bargain_goods } from '@/api/market.js'
export default {
    name:'add',
    data () {
        return {
            skuItems: [],
            start_time: '',
            end_time: '',
            obj: {},
            status: 0,
            titleShow: false
        }
    },
    methods:{
        // 获取商品sku
        getSku() {
            goods_sku(this.$route.query.id).then(res => {
                if(res) {
                    this.skuItems = res.data
                    this.skuItems.forEach(item => {
                        item.stock = item.sku_stock.stock
                    })
                }
            })
        },
        // sku 一键复制
        handleSkuCopy() {
            let len = this.skuItems.length
            for(let i=1; i<len; i++ ) {
                this.skuItems[i].sales_price = this.skuItems[0].sales_price
                this.skuItems[i].count = this.skuItems[0].count
                this.skuItems[i].sales_stock = this.skuItems[0].sales_stock
                this.skuItems[i].buy_limit = this.skuItems[0].buy_limit
                this.skuItems[i].cut_type = this.skuItems[0].cut_type
            }
            this.$forceUpdate();
        },
        handleSubmit() {
            let params = {
                bargain_goods_id: this.titleShow ? 0: this.obj.id ,
                goods_id: this.$route.query.id
            }
            if(this.start_time == '') {
                this.$message({type:'warning',message:'请选择开始时间'})
                return false
            }
            if(this.end_time == '') {
                this.$message({type:'warning',message:'请选择结束时间'})
                return false
            }
            params.start_time = parseTime(this.start_time)
            params.end_time = parseTime(this.end_time)
            let list = []
            this.skuItems.forEach(e => {
                list.push({
                    bargain_goods_sku_id: this.titleShow ? 0 : e.bargain_goods_sku_id,
                    goods_sku_id: e.id,
                    count: e.count,
                    sales_price: e.sales_price,
                    sales_stock: e.sales_stock,
                    buy_limit: e.buy_limit,
                    cut_type: e.cut_type,
                    status: 1
                })
            })
            let skuBol = false;
            list.forEach(it => {
                for (let key in it) {
                    if(it[key] === '' || it[key] === undefined) {
                        skuBol = true;
                    }
                }
            })
            if (skuBol) {
                this.$message.error("请务必完善SKU每条信息");
                return false;
            }
            params.goods_sku = list
            if(sessionStorage.getItem('goods_sku')) {
                put_bargain_goods(params).then(res => {
                    if(res) {
                        this.$message({type:'success',message:'修改成功'})
                        this.$router.go(-1)
                    }
                })
            } else {
                add_bargain_goods(params).then(res => {
                    if(res) {
                        this.$message({type:'success',message:'添加成功'})
                        this.$router.go(-1)
                    }
                })
            }
        }
    },
    activated() {
        this.skuItems = []
        if(sessionStorage.getItem('goods_sku')) {
            this.titleShow = false
            this.obj = JSON.parse(sessionStorage.getItem('goods_sku'))
            this.start_time = new Date(this.obj.start_time)
            this.end_time = new Date(this.obj.end_time)
            this.obj.goods.goods_sku.forEach(e => {
                this.skuItems.push({
                    attr_symbol_string: e.attr_symbol_string,
                    barcode: e.barcode,
                    price: e.price,
                    bargain_goods_sku_id: e.bargain_goods_sku ? e.bargain_goods_sku.id : 0,
                    id: e.id,
                    stock: e.sku_stock.stock,
                    count: e.bargain_goods_sku ? e.bargain_goods_sku.count : '',
                    sales_price: e.bargain_goods_sku ? e.bargain_goods_sku.sales_price : '',
                    sales_stock: e.bargain_goods_sku ? e.bargain_goods_sku.sales_stock : '',
                    buy_limit: e.bargain_goods_sku ? e.bargain_goods_sku.buy_limit : '',
                    cut_type: e.bargain_goods_sku ? e.bargain_goods_sku.cut_type.toString() : '',
                })
            })
            console.log(this.skuItems)
        } else {
            this.titleShow = true
            this.getSku()
        }
    }
}
</script>
<style lang="less" scoped>
.sizing {
    box-sizing: border-box;
}
section {
    .title {
        margin-left: 10px;
        p:nth-child(1) {
            text-decoration: underline;
            color: #169bff;
            margin-bottom: 10px;
            cursor: pointer;
        }
        p:nth-child(2) {
            margin-bottom: 10px;
            font-size: 26px;
            font-weight: bold;
            color: #0A1629;
        }
    }
    /deep/ .el-input__inner {
        height: 40px;
    }
    .input-left {
        height: 40px;
        line-height: 40px;
        min-width:80px ;
    }
    .m-width-125 {
        width: 125px;
    }
    .m-width-145 {
        width: 145px;
    }
    .m-width-165 {
        width: 165px;
    }
    .readonly {
        /deep/ .el-input__inner {
            background: #ddd; 
            color: #333;
            cursor: default;
        }
    }
    /deep/ .el-input--small .el-input__inner {
        text-align: center;
    }
    .sku-items-head {
        min-width: 1060px;
        display: flex;
        background: #f5f7fa;
        border: 1px solid #e8e8e8;
        >div {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 50px;
            font-size: 15px;
            margin-left: 10px;
            color: #8c939d;
            >span {
                display: inline-block;
                width: 100%;
                height: 36px;
                background: #fff;
                text-align: center;
                line-height: 36px;
            }
        }
    }
    .sku-items-body {
        min-width: 1060px;
        display: flex;
        border: 1px solid #e8e8e8;
        border-top: none;
        >div {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 80px;
            margin-left: 10px;
            font-size: 15px;
            color: #8c939d;
            >p {
                display: flex;
                align-items: center;
                justify-content: center;
                text-align: center;
                width: 100%;
                height: 40px;
                font-size: 13px;
                background: #ddd;
                color: #333;
                border-radius: 5px;
            }
        }
        .avatar-uploader-icon {
            width: 60px;
            height: 60px ;
            line-height: 60px !important;
            border: 1px solid #e0e0e0;
        }
    }
    .sku-tips {
        height: 30px;
        line-height: 30px;
        margin-top: 5px;
        color: red;
    }
}
</style>

